import { useEffect } from 'react';
import { Tabs } from '../types/tabs';

const TAB_TITLES: Record<Tabs, string> = {
  [Tabs.HOME]: 'Home',
  [Tabs.WORKSPACE]: 'Workspace',
  [Tabs.NOTEBOOK]: 'Code',
  [Tabs.ASSETS]: 'Assets',
  [Tabs.SCENARIOS]: 'Scenarios',
  [Tabs.USAGE]: 'Usage',
  [Tabs.DOCS]: 'Docs',
  [Tabs.ADMIN]: 'Admin',
  [Tabs.ONTOLOGY]: 'Antioch Ontology',
  [Tabs.SETTINGS]: 'Settings',
  [Tabs.TEAM]: 'Team',
};

const BASE_TITLE = 'Antioch';

/**
 * Updates the document title based on the current tab.
 *
 * @param currentTab - The currently active tab.
 */
export function useDocumentTitle(currentTab: Tabs): void {
  useEffect(() => {
    const pageTitle = TAB_TITLES[currentTab];
    document.title = pageTitle ? `${pageTitle} | ${BASE_TITLE}` : BASE_TITLE;

    // Restore base title on unmount
    return () => {
      document.title = BASE_TITLE;
    };
  }, [currentTab]);
}
